(() => {
  const repositionShareTool = (tool) => {
    // Move the share row to sit near the top of the page, right after the
    // page's top hero/header block, rather than nested inside it (a coloured
    // hero box, say) or left at the very end of the template.
    if (tool.dataset.gcrSharePositioned === 'true') return;

    const main = document.querySelector('#MainContent') || document.body;
    const heading = main.querySelector('h1');

    if (heading) {
      let anchor = heading;
      while (anchor.parentElement && anchor.parentElement !== main) {
        anchor = anchor.parentElement;
      }
      if (anchor.parentElement === main) {
        anchor.insertAdjacentElement('afterend', tool);
      }
    }

    tool.dataset.gcrSharePositioned = 'true';
  };

  const initShareTool = (root = document) => {
    root.querySelectorAll('[data-gcr-share-tool]:not([data-gcr-share-ready])').forEach((tool) => {
      tool.setAttribute('data-gcr-share-ready', 'true');

      repositionShareTool(tool);

      const nativeButton = tool.querySelector('[data-gcr-share-native]');
      const copyButton = tool.querySelector('[data-gcr-share-copy]');
      const copyIcon = copyButton.querySelector('.gcr-share__copy-icon');
      const checkIcon = copyButton.querySelector('.gcr-share__check-icon');
      const copyLabel = copyButton.querySelector('[data-gcr-share-copy-label]');
      const emailLink = tool.querySelector('[data-gcr-share-email]');
      const facebookLink = tool.querySelector('[data-gcr-share-facebook]');
      const whatsappLink = tool.querySelector('[data-gcr-share-whatsapp]');
      const status = tool.querySelector('[data-gcr-share-status]');
      const url = window.location.href;
      const title = tool.dataset.shareTitle || document.title;

      const encodedUrl = encodeURIComponent(url);
      const encodedTitle = encodeURIComponent(title);
      emailLink.href = `mailto:?subject=${encodedTitle}&body=${encodeURIComponent(title + '\n\n' + url)}`;
      facebookLink.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      whatsappLink.href = `https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`;

      // Only show the native "more options" share icon where the browser
      // actually supports it (mostly mobile) — every other platform icon is
      // always visible, so nothing is hidden behind an extra click.
      if (navigator.share) {
        nativeButton.hidden = false;
        nativeButton.addEventListener('click', async () => {
          try {
            await navigator.share({ title, url });
          } catch (error) {
            // Ignore cancellations; anything else fails silently since the
            // platform icons remain available as a fallback.
          }
        });
      }

      const setStatus = (message) => {
        status.textContent = message;
        if (message) {
          window.setTimeout(() => {
            if (status.textContent === message) status.textContent = '';
          }, 4000);
        }
      };

      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(url);
        } catch (error) {
          const textArea = document.createElement('textarea');
          textArea.value = url;
          textArea.setAttribute('readonly', '');
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
        }

        copyButton.setAttribute('data-copied', 'true');
        copyIcon.hidden = true;
        checkIcon.hidden = false;
        if (copyLabel) copyLabel.textContent = 'Link copied';
        setStatus('Link copied');

        window.setTimeout(() => {
          copyButton.removeAttribute('data-copied');
          copyIcon.hidden = false;
          checkIcon.hidden = true;
          if (copyLabel) copyLabel.textContent = 'Copy link';
        }, 4000);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initShareTool());
  } else {
    initShareTool();
  }

  document.addEventListener('shopify:section:load', (event) => initShareTool(event.target));
})();
